import { NUMBER_OF_ELEMENTS_WITH_SMALL_GAP } from '@interlayer/js/app/components/main/Promotions/constants';

const SMALL_GAP = 10;
const LARGE_GAP = 19;
const MOBILE_COEFFICIENT = 0.868;
const DESKTOP_COEFFICIENT = 1;

export const calculationElementWidth = ({
    element,
    numberOfElements,
    isDesktop
}: {
    element: HTMLDivElement | null;
    numberOfElements: number;
    isDesktop: boolean;
}): number => {
    if (!element) {
        return 0;
    }

    const gap = Number(numberOfElements) > NUMBER_OF_ELEMENTS_WITH_SMALL_GAP || !isDesktop ? SMALL_GAP : LARGE_GAP;
    const coefficient = isDesktop ? DESKTOP_COEFFICIENT : MOBILE_COEFFICIENT;

    return (element.offsetWidth * coefficient - gap * (Number(numberOfElements) - 1)) / Number(numberOfElements);
};
